/**
 * 下载过程
 * 
 * ================================================================================================================================
 * 
 * h5-- -- - > 提交下载任务------------------------------------------------------------------------------------------------完成-------
 *                  |                                                                                               |
 * app-- -- -- -- -- -- -- > 获取预下载--------------------------------> 获取阿里云token -----------> 下载 --------->解压--------------
 *                              |                             |                 |                     |
 * 知书---------------------------------> 打包上传阿里 ----> 可下载-----------------------------------  |
 *                                               |                                                    |
 *                                               |                                                    |
 * 阿里云---------------------------------------------------------------------------------------------------------------------------
 * 
 * 
 * ==================================================================================================================================
 * 
 * 
 * 
 * 客户端status回调状态
 * 
 * ==================================================================================================================================
 *  1, //    等待下载
    2, //    预下载获取阿里云下载地址
    3, //    预下载获取token失败
    4, //    文件下载开始
    5, //    文件下载成功
    6, //    阿里云下载失败
    7, //    文件下载后解压中
    8, //    解压失败
    9, //    所有事件完成
    10, //   文件不存在下载队列
    11, //   文件已经存在下载队列
    100 //
 * ==================================================================================================================================

  查找本地下載記錄 getLocalEpub 方法回調監聽
  window["epubLocalResultList"] = this.epubLocalResultList;


  下載進度回調監聽
  window["epubDownloadProgress"] = this.epubDownloadProgressFun;



 */

import {
  SERVER,
} from "@/api/apiConfig.js";
import UTILS from "@/utils/utils.js";

var langTW = require('@/common/lang/tw.js')
var langZH = require('@/common/lang/zh.js')

var lang = UTILS.getLanguage(SERVER.DEV)

// console.log('使用的語言', lang)

var useLang = lang == 'zh-hk' ? langTW : langZH

/** 
 * 下载方法， 启动下载 ， 并监听客户端回调epubDownloadProgress 方法 
 * 
 * @param  {Object} data  参数接收内容如下
 * @param  {String} bookKey  电子书id
 * @param  {String} url  下载url
 * @param  {String} image  封面图
 * @param  {String} title  标题
 * @param  {String} lang  語言 下载进度回调方法就必傳入
 * @param  {Function} fail  调用失败回调函数
 * @param  {Boolean} isRetry  重试下载   
 */
function download(downData) {

  // console.log('alldownData', downData);
  // !downData.bookKey || !downData.url || !downData.image || !downData.title

  if (!downData.bookKey || !downData.url || !downData.title) {

    // console.log('alldownData 缺少参数')
    downData.fail({
      code: -1,
      message: useLang.down_JS.noParameter
    })
    return
  }


  var obj = {
    bookKey: downData.bookKey,
    url: downData.url,
    image: downData.image,
    title: downData.title
  };

  // console.log(downData.isRetry)
  // console.log('download', downData)

  if (downData.isRetry) {
    //重新下载
    native.retryDownloadEpub(JSON.stringify(obj));
  } else {
    native.downloadEpub(JSON.stringify(obj));
  }

  let checkObj = {
    bookKey: `${downData.bookKey}`
  };

  // console.log(checkObj)

  native.getEpubDownloadProgress(JSON.stringify(checkObj));

}

/** 
 * 检查状态
 * @param  {Object} checkData
 * @param  {number} status 客户端回调status状态
 * @param  {Object} data 下载进度数据
 * @param  {Function} start 开始下载
 * @param  {Function} success 成功
 * @param  {Function} fail 失败 返回code  
 * @param  {Function} processing 处理中 更具status返回文字描述
 * @param  {Function} allSuccess 所有任务时间处理完成
 */
function checkStatus(checkData) {
  // console.log('run this checkStatus')
  if (!checkData.success || !checkData.processing || !checkData.status) {

    checkData.fail({
      code: -1,
      message: useLang.down_JS.noParameter
    })

    return
  }

  switch (checkData.status) {
    case 1: //等待下載
      checkData.processing(useLang.down_JS.status1)
      break;
    case 2: //獲取下載地址
      checkData.processing(useLang.down_JS.status2)
      break;
    case 3: //獲取地址失敗
      checkData.fail({
        code: 0,
        message: useLang.down_JS.status3
      })
      break;
    case 4:
      // 下載開始
      checkData.start(checkData.data)
      break;
    case 5: //下載成功
      //因为5-9是在一个线程同步返回，貌似没办法全部回调
      checkData.processing(useLang.down_JS.status5)
      break;
    case 6: //下載失敗，請重新下載
      checkData.fail({
        code: 1,
        message: useLang.down_JS.status6
      })
      break;
    case 7: //解壓中
      checkData.processing(useLang.down_JS.status7)
      break;
    case 8: //解壓失敗，請重新下載
      checkData.fail({
        code: 2,
        message: useLang.down_JS.status8
      })
      break;
    case 9:
      //下载成功
      checkData.success()
      break;
    case 10:
      //注释，下载接口调用会触发一次，不返回该类型错误信息
      // checkData.fail({
      //   code: 3,
      //   message: '文件不存在下载队列'
      // })
      break;
    case 11: //文件已经存在下载队列，請重試
      checkData.fail({
        code: 4,
        message: useLang.down_JS.status11
      })
      break;
    case 12:
      if (checkData.allSuccess) {
        checkData.allSuccess()
      } else { //所有任务下载完成
        checkData.processing(useLang.down_JS.status12)
      }
      break;
    case 100: //未知错误
      checkData.fail({
        code: 5,
        message: useLang.down_JS.status100
      })
      break;
  }


}
/**
 * 删除本地缓存的电子书
 * @param  {Array} deleData
 */
function deleEpub(deleData) {


  var obj = {
    item: deleData
  }

  // console.log('dele', obj)

  native.deleEpub(JSON.stringify(obj))


}

/**
 * 获取电子书下载记录
 * @param  {String} bookKey
 */
function getLocal(bookKey) {
  var obj = {};

  if (bookKey) {
    obj['bookKey'] = bookKey
  }

  // console.log('getLocalEpub bookKey =>', bookKey)

  native.getLocalEpub(JSON.stringify(obj));

}


export default {

  download,
  checkStatus,
  deleEpub,
  getLocal

}



// WEBPACK FOOTER //
// ./src/utils/cc-webapp/downloadEpub.js